<template>
  <div>
    <button
      class="btn multi unicode"
      v-bind:class="{
        rounded: rounded,
        bordered: bordered,
        'form-control': rounded | bordered,
        'input-text': rounded | bordered,
      }"
      v-c-tooltip.click="'klik 2x untuk edit'"
      @click="doEdit"
      v-show="!isEdit"
    >
      {{ value | thousandSeparator }}
    </button>
    <input
      type="number"
      ref="edit"
      class="form-control multi"
      v-model="value"
      v-bind:class="{ rounded: rounded, bordered: bordered }"
      @blur="noEdit"
      @keyup="keyUp"
      v-show="isEdit"
    />
  </div>
</template>
<script>
export default {
  name: "ButtonEditInput2",
  props: {
    value: {
      type: Number,
    },
    rounded: {
      type: Boolean,
    },
    bordered: {
      type: Boolean,
    },
    control: {
      type: Boolean,
    },
  },
  created () {
  },
  data () {
    return {
      isEdit: false,
    };
  },
  methods: {
    doEdit () {
      this.isEdit = true;
      this.$refs.edit.focus();
    },
    noEdit () {
      this.isEdit = false;
      this.$emit('input', this.value)
      this.$emit('change')
    },
    keyUp (e) {
      if (e.keyCode == 13) {
        this.noEdit();
      }
    },
  },
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.multi {
  padding: 3px;
  width: 100%;
  text-align: right;
  border-radius: 0;
  height: 35px;
}
.input-text {
  padding: 0.375rem 0.75rem;
}
</style>